function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["value", "onChange", "useDragger", "usePaste", "readonly", "disabled", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
import { Input, Upload } from 'antd';
import { nanoid } from 'nanoid';
import { useState } from 'react';
import Compressor from 'compressorjs';
import { post } from "../utils";
import { message } from "./GlobalMessage";
import axios from 'axios';

/** 签名数据全局变量存储,  */
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var OSSData = undefined;
var getOSSData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var nextOSSData;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(!OSSData || OSSData.expires < Date.now())) {
            _context.next = 5;
            break;
          }
          _context.next = 3;
          return queryOSSData();
        case 3:
          nextOSSData = _context.sent;
          return _context.abrupt("return", nextOSSData);
        case 5:
          return _context.abrupt("return", OSSData);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getOSSData() {
    return _ref.apply(this, arguments);
  };
}();
export var AliyunOSSUpload = function AliyunOSSUpload(_ref2) {
  var value = _ref2.value,
    onChange = _ref2.onChange,
    useDragger = _ref2.useDragger,
    usePaste = _ref2.usePaste,
    readonly = _ref2.readonly,
    disabled = _ref2.disabled,
    children = _ref2.children,
    otherProps = _objectWithoutProperties(_ref2, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focused = _useState2[0],
    setFocused = _useState2[1];
  // const update = useUpdate()

  var handleChange = function handleChange(_ref3) {
    var fileList = _ref3.fileList;
    // console.log('Aliyun OSS:', fileList)
    onChange === null || onChange === void 0 || onChange(_toConsumableArray(fileList));
  };
  var getAction = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getOSSData();
          case 2:
            OSSData = _context2.sent;
            return _context2.abrupt("return", OSSData.uploadHost);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getAction() {
      return _ref4.apply(this, arguments);
    };
  }();
  var getExtraData = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(uploadFile) {
      var objectName, key, fileUrl, parsedFile;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getOSSData();
          case 2:
            OSSData = _context3.sent;
            objectName = "".concat(nanoid(), "/").concat(uploadFile.name);
            key = "".concat(OSSData.dir).concat(objectName); // const orgFileUrl = `${OSSData.downloadUrl}${encodeURIComponent(objectName)}`
            fileUrl = "".concat(OSSData.uploadHost, "/").concat(key);
            parsedFile = uploadFile['parsedFile'];
            uploadFile.url = fileUrl;
            if (parsedFile) {
              parsedFile.url = fileUrl;
            }
            if (uploadFile.originFileObj) {
              // @ts-ignore
              uploadFile.originFileObj.url = fileUrl;
            }
            return _context3.abrupt("return", {
              key: key,
              OSSAccessKeyId: OSSData.accessId,
              policy: OSSData.policy,
              Signature: OSSData.signature
            });
          case 11:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function getExtraData(_x) {
      return _ref5.apply(this, arguments);
    };
  }();
  var handlePaste = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(event) {
      var _event$clipboardData;
      var files, fileList, upList, fdList, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, close, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, fd, idx, uploadFile, actionUrl, _yield$axios, status, request, data, statusText;
      return _regeneratorRuntime().wrap(function _callee4$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            event.preventDefault();
            files = Array.from((event === null || event === void 0 || (_event$clipboardData = event.clipboardData) === null || _event$clipboardData === void 0 ? void 0 : _event$clipboardData.files) || []).filter(function (f) {
              return f.type;
            });
            fileList = [];
            if (!(files.length === 0)) {
              _context5.next = 6;
              break;
            }
            message.info('请粘贴单/多个文件, 不支持文件夹');
            return _context5.abrupt("return");
          case 6:
            upList = [];
            fdList = [];
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context5.prev = 10;
            _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
              var file, uploadFile, extData, fd;
              return _regeneratorRuntime().wrap(function _loop$(_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    file = _step.value;
                    if (file) {
                      _context4.next = 3;
                      break;
                    }
                    return _context4.abrupt("return", 1);
                  case 3:
                    uploadFile = {
                      uid: nanoid(),
                      size: file.size,
                      name: file.name,
                      fileName: file.name,
                      lastModified: file.lastModified
                    };
                    _context4.next = 6;
                    return getExtraData(uploadFile);
                  case 6:
                    extData = _context4.sent;
                    upList.push(uploadFile);
                    fd = new FormData();
                    Object.keys(extData).forEach(function (key) {
                      fd.append(key, extData[key]);
                    });
                    fd.append('file', file);
                    fdList.push(fd);
                  case 12:
                  case "end":
                    return _context4.stop();
                }
              }, _loop);
            });
            _iterator = _asyncIterator(files);
          case 13:
            _context5.next = 15;
            return _iterator.next();
          case 15:
            if (!(_iteratorAbruptCompletion = !(_step = _context5.sent).done)) {
              _context5.next = 22;
              break;
            }
            return _context5.delegateYield(_loop(), "t0", 17);
          case 17:
            if (!_context5.t0) {
              _context5.next = 19;
              break;
            }
            return _context5.abrupt("continue", 19);
          case 19:
            _iteratorAbruptCompletion = false;
            _context5.next = 13;
            break;
          case 22:
            _context5.next = 28;
            break;
          case 24:
            _context5.prev = 24;
            _context5.t1 = _context5["catch"](10);
            _didIteratorError = true;
            _iteratorError = _context5.t1;
          case 28:
            _context5.prev = 28;
            _context5.prev = 29;
            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context5.next = 33;
              break;
            }
            _context5.next = 33;
            return _iterator.return();
          case 33:
            _context5.prev = 33;
            if (!_didIteratorError) {
              _context5.next = 36;
              break;
            }
            throw _iteratorError;
          case 36:
            return _context5.finish(33);
          case 37:
            return _context5.finish(28);
          case 38:
            close = message.loading('正在上传');
            _iteratorAbruptCompletion2 = false;
            _didIteratorError2 = false;
            _context5.prev = 41;
            _iterator2 = _asyncIterator(fdList);
          case 43:
            _context5.next = 45;
            return _iterator2.next();
          case 45:
            if (!(_iteratorAbruptCompletion2 = !(_step2 = _context5.sent).done)) {
              _context5.next = 75;
              break;
            }
            fd = _step2.value;
            idx = fdList.indexOf(fd);
            uploadFile = upList[idx];
            if (uploadFile.originFileObj) {
              _context5.next = 51;
              break;
            }
            return _context5.abrupt("continue", 72);
          case 51:
            _context5.prev = 51;
            _context5.next = 54;
            return getAction(uploadFile.originFileObj);
          case 54:
            actionUrl = _context5.sent;
            _context5.next = 57;
            return axios({
              url: actionUrl,
              method: 'POST',
              data: fd
            });
          case 57:
            _yield$axios = _context5.sent;
            status = _yield$axios.status;
            request = _yield$axios.request;
            data = _yield$axios.data;
            statusText = _yield$axios.statusText;
            if (!(status < 200 || status >= 300)) {
              _context5.next = 65;
              break;
            }
            // error
            console.log(data, statusText);
            throw new Error('Request Error');
          case 65:
            fileList.push(_objectSpread(_objectSpread({}, uploadFile), {}, {
              xhr: request,
              status: 'done'
            }));
            _context5.next = 72;
            break;
          case 68:
            _context5.prev = 68;
            _context5.t2 = _context5["catch"](51);
            console.error(_context5.t2);
            message.error('上传失败, 原因: ' + _context5.t2.message || 'UNKNOWN');
          case 72:
            _iteratorAbruptCompletion2 = false;
            _context5.next = 43;
            break;
          case 75:
            _context5.next = 81;
            break;
          case 77:
            _context5.prev = 77;
            _context5.t3 = _context5["catch"](41);
            _didIteratorError2 = true;
            _iteratorError2 = _context5.t3;
          case 81:
            _context5.prev = 81;
            _context5.prev = 82;
            if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
              _context5.next = 86;
              break;
            }
            _context5.next = 86;
            return _iterator2.return();
          case 86:
            _context5.prev = 86;
            if (!_didIteratorError2) {
              _context5.next = 89;
              break;
            }
            throw _iteratorError2;
          case 89:
            return _context5.finish(86);
          case 90:
            return _context5.finish(81);
          case 91:
            close();
            onChange === null || onChange === void 0 || onChange([].concat(_toConsumableArray(value || []), fileList));
          case 93:
          case "end":
            return _context5.stop();
        }
      }, _callee4, null, [[10, 24, 28, 38], [29,, 33, 37], [41, 77, 81, 91], [51, 68], [82,, 86, 90]]);
    }));
    return function handlePaste(_x2) {
      return _ref6.apply(this, arguments);
    };
  }();
  var uploadProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    disabled: readonly || disabled,
    name: 'file',
    fileList: value,
    action: getAction,
    beforeUpload: function beforeUpload(file, fileList) {
      var uid = file.uid,
        lastModifiedDate = file.lastModifiedDate;
      var convertTypes = ['image/png', 'image/jpeg', 'image/webp'];
      if (!convertTypes.includes(file.type)) {
        return true;
      }
      var result = new Promise(function (resolve, reject) {
        new Compressor(file, {
          maxWidth: 2560,
          maxHeight: 2560,
          quality: 0.8,
          // mimeType: 'image/webp',
          convertTypes: convertTypes,
          convertSize: 2000000,
          success: function success(fileBlob) {
            var name = (fileBlob === null || fileBlob === void 0 ? void 0 : fileBlob['name']) || file.name;
            var type = fileBlob.type || file.type;
            var nextFile = new File([fileBlob], name, {
              type: type
            });
            nextFile.uid = uid;
            Object.defineProperty(nextFile, 'lastModifiedDate', {
              value: lastModifiedDate,
              writable: false
            });
            var orgSize = (file.size / 1024).toFixed(2) + 'KB';
            var nextSize = (nextFile.size / 1024).toFixed(2) + 'KB';
            var rate = ((file.size - nextFile.size) / file.size * 100).toFixed(2) + '%';
            console.log("\u538B\u7F29\u6210\u529F: ".concat(nextFile.name, " ").concat(orgSize, " \u2192 ").concat(nextSize, " (-").concat(rate, ")"));
            file['parsedFile'] = nextFile;
            resolve(nextFile);
          },
          error: function error(_error) {
            // console.log('压缩失败', error)
            resolve(file);
          }
        });
      });
      return result;
    },
    onChange: handleChange,
    data: getExtraData
  });
  var Component = useDragger ? Upload.Dragger : Upload;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, uploadProps), {}, {
      children: children == null || children === false ? null : children
    })), usePaste ? /*#__PURE__*/_jsx(Input, {
      style: {
        color: 'transparent'
      },
      onFocus: function onFocus() {
        setFocused(true);
      },
      onBlur: function onBlur() {
        setFocused(false);
      },
      onPaste: handlePaste,
      value: undefined,
      placeholder: focused ? '在此处粘贴文件上传' : '点击聚焦可粘贴文件上传'
    }) : null]
  });
};
export default AliyunOSSUpload;

/**
 * 授权信息
 *
 * OSSPostObjectVo
 */

var queryOSSData = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var _yield$post, resData;
    return _regeneratorRuntime().wrap(function _callee5$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return post({
            url: '/assistant/oss/get/post/object/info/v1'
          });
        case 2:
          _yield$post = _context6.sent;
          resData = _yield$post.data;
          return _context6.abrupt("return", resData);
        case 5:
        case "end":
          return _context6.stop();
      }
    }, _callee5);
  }));
  return function queryOSSData() {
    return _ref7.apply(this, arguments);
  };
}();